/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 관리자페이지 팀 수정 모달창
 * 버전 : 1.0
 * 파일명 : ModalTitleModifyTeam.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * ================================================================ 
 * 수정일 : 2025-12-26, 강동형 : 데이터 갱신추가
 * ================================================================ 
 */

import { useEffect } from 'react'
import { useExtraModalStore, useModalStore } from 'src/stores/ModalStore'
import styled from 'styled-components'
import { ActionButton, NextButton } from '../common/CommonStyled'
import { Divider } from '@mui/material'
import { useAdTeamStore } from 'src/stores/AdTeamStore'
import { patchTeamUpdate } from 'src/api/Admin'
import ExtraModalDeleteCheck from './ExtraModalDeleteCheck'
import { toast } from 'react-toastify'
import { LoadTeam } from './useLoadTeam'
import { refetchUser } from 'src/utils/RefetchUser'

const PageWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    position: relative;
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 20px;
`
const ButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;

    height: 54px;
    position: absolute;
    right: 0;
`

const ModalTitleModifyTeam = () => {
    const modalSetField = useModalStore((state)=>state.setField)
    const extraModalSetField = useExtraModalStore((state)=>state.setField)
    const team_name = useAdTeamStore((state)=>state.team_name)
    const manager_uid = useAdTeamStore((state)=>state.manager_uid)
    const memberList = useAdTeamStore((state)=>state.memberList)
    const team_areas = useAdTeamStore((state)=>state.team_areas)
    const setField = useAdTeamStore((state)=>state.setField)
    const reset = useAdTeamStore((state)=>state.reset)
    const selectedTeam = useAdTeamStore((state)=>state.selectedTeam)
    const regionArray: [string, string[]][] = Object.entries(team_areas);
    useEffect(()=>{
        return(()=>{
            reset(['selectedTeam','tableData'])
        })
    },[])

    useEffect(()=>{
        if (!member_uids.includes(manager_uid)){
            setField('manager_uid','')
            return
        }
    },[memberList])
    const member_uids = memberList.map((member) => member.uid);

    const onClickSubmit = async ()=>{
        if(!team_name) return toast.error('팀 명이 없습니다.',{autoClose:2000})

        const response = await patchTeamUpdate({
            team_name, 
            manager_uid,
            member_uids: member_uids,
            team_areas: regionArray,
            team_id:selectedTeam?.team_id ?? 0
        })

        if(response.status === 200){
            LoadTeam()
            refetchUser()
            modalSetField('open',false)
        }
        else{
            return
        }
    }

    const onClickDelete = ()=>{
        extraModalSetField('width','466px')
        extraModalSetField('padding','32px')
        extraModalSetField('content',<ExtraModalDeleteCheck/>)
        extraModalSetField('open',true)
    }

    return (
        <>
        <PageWrapper>
            <ActionButton style={{width:'94px', height:'54px', position:'absolute',left:0}} onClick={onClickDelete}>삭제</ActionButton>
            팀 수정
            <ButtonWrapper>
                <ActionButton style={{width:'94px', height: '54px'}} onClick={()=>modalSetField('open',false)}>취소</ActionButton>
                <NextButton style={{width:'94px', height:'100%'}} onClick={onClickSubmit} disabled={false}>수정 완료</NextButton>
            </ButtonWrapper>
        </PageWrapper>
        <Divider sx={{width:'100%', borderColor:'#D1D1D1'}}/>
        </>
    )
}

export default ModalTitleModifyTeam